// extracted by mini-css-extract-plugin
export default {"upsContainer":"Features_upsContainer__dL7Ii"};